<template>
  <v-container fluid class="ma-0 pa-0">
    <v-container class="header pb-0" fluid>
      <v-layout column justify-center align-center>
        <v-col xl="12" lg="12" md="12" sm="12" class="pb-0">
          <v-layout align-center style="height: 130px">
            <v-layout row style="position: absolute">
              <v-img
                @click="goBack()"
                height="45"
                width="45"
                class="shrink pointer"
                contain
                :src="require('../../assets/back.png')"
              />
              <div class="ml-3" style="color: #fff; width: 96px">Back to profuse.md</div>
            </v-layout>
            <v-col xl="8" lg="9" md="10" sm="12" class="pb-0 mx-auto">
              <Toolbar />
            </v-col>
          </v-layout>
        </v-col>

        <v-col xl="8" lg="10" md="10" sm="12" class="pb-0">
          <v-layout column class="mt-9 header-content">
            <v-layout row align-center>
              <v-col lg="6" md="6" sm="10" class="mx-auto my-auto">
                <v-layout column>
                  <div class="app-title">The Best Action Alien Shooting Game!</div>
                  <div
                    class="description"
                  >Take on many challenges & boss monsters in this exciting action arcade game!</div>

                  <v-layout>
                    <v-flex shrink mr-9 mb-5 class="store_btn">
                      <v-img
                        @click="openAppStore"
                        height="58"
                        width="170"
                        contain
                        :src="require('../../assets/app_store.png')"
                      />
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-col>

              <v-col lg="6" md="6" sm="12" class="mb-9 hidden-sm-and-down">
                <v-layout justify-center>
                  <v-col md="12" sm="8">
                    <v-img contain :src="require('../../assets/galaxyBirds/screenshot1.png')" />
                  </v-col>
                </v-layout>
              </v-col>
            </v-layout>

            <v-flex shrink justify-start class="player-yellow">
              <v-col cols="6" class="pb-0">
                <v-img height="121" contain :src="require('../../assets/galaxyBirds/player.png')" />
              </v-col>
            </v-flex>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="main-features" fluid>
      <v-layout justify-center>
        <v-col xl="8" lg="10" md="10" sm="12">
          <v-layout row align-center justify-center>
            <v-col lg="6" md="6" sm="8">
              <v-layout justify-center>
                <v-img contain :src="require('../../assets/galaxyBirds/main-features.png')" />
              </v-layout>
            </v-col>

            <v-col lg="6" md="6" sm="12">
              <v-layout column align-center>
                <v-layout column>
                  <div class="features-title">Main Features</div>
                  <div class="features-item">• HQ Graphics optimized for all devices</div>
                  <div class="features-item">• Fast-paced action shooting</div>
                  <div class="features-item">• Lucky clovers ( Make it rain money! )</div>
                  <div class="features-item">• Loads of levels to immerse yourself in</div>
                  <div class="features-item">• Many boss monsters to fight and overcome</div>
                  <div class="features-item">• Arcade & Story Modes</div>
                  <div
                    class="features-item"
                  >• 3 High Score Lists ( Best Score, Coins, & Levels unlocked )</div>
                  <div class="features-item">• Free to Play</div>
                </v-layout>
              </v-layout>
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>

      <v-layout justify-end>
        <v-col cols="5">
          <v-img height="122" contain :src="require('../../assets/galaxyBirds/player_yellow.png')" />
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="rating pa-0" fluid>
      <v-layout column align-center>
        <div class="rating-title">Ratings & Reviews</div>
        <v-col xl="8" md="10" sm="10" class="pa-0">
          <v-layout align-content-space-between align-center justify-center>
            <v-flex shrink class="pointer" @click="carouseItemIndex--">
              <v-img
                height="50"
                width="50"
                contain
                :src="require('../../assets/galaxyBirds/prev.png')"
              />
            </v-flex>

            <v-layout column align-center>
              <v-col md="8" sm="12">
                <v-carousel
                  v-model="carouseItemIndex"
                  cycle
                  hide-delimiters
                  height="250"
                  :show-arrows="false"
                >
                  <v-carousel-item v-for="(review, i) in reviews" :key="i">
                    <v-sheet color="transparent" height="100%">
                      <v-layout column align-center>
                        <v-rating class="mt-9" readonly color="#FBB831" v-model="review.rating"></v-rating>
                        <div class="review-text">{{ review.text }} Slide</div>
                        <div class="review-author">{{ review.author }}</div>
                      </v-layout>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </v-col>
            </v-layout>

            <v-flex shrink class="pointer" @click="carouseItemIndex++">
              <v-img
                height="50"
                width="50"
                contain
                :src="require('../../assets/galaxyBirds/next.png')"
              />
            </v-flex>
          </v-layout>
        </v-col>
      </v-layout>
      <v-layout justify-start>
        <v-col cols="5">
          <v-img height="122" contain :src="require('../../assets/galaxyBirds/player_green.png')" />
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="download-container pt-0" fluid>
      <v-layout justify-center>
        <v-col xl="8" md="10" sm="12" class="pt-0">
          <v-img height="221" contain :src="require('../../assets/galaxyBirds/galaxy_birds.png')" />

          <v-layout class="mt-9 pt-9" row justify-center>
            <v-col lg="6" md="10" sm="12" class="align-self-center">
              <div class="download-app">Download the Free Galaxy Birds App</div>
              <v-layout>
                <v-flex shrink mr-9 mb-5 class="store_btn">
                  <v-img
                    @click="openAppStore"
                    height="58"
                    width="170"
                    contain
                    :src="require('../../assets/app_store.png')"
                  />
                </v-flex>
              </v-layout>
            </v-col>
            <v-col lg="6" md="10" sm="12">
              <v-img contain :src="require('../../assets/galaxyBirds/app_screenshots.png')" />
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="footer pb-9" fluid>
      <v-layout justify-center>
        <v-col xl="8" lg="10" md="10" sm="12">
          <Toolbar />
        </v-col>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import Toolbar from "./components/Toolbar";
export default {
  components: {
    Toolbar
  },
  data() {
    return {
      carouseItemIndex: 0,
      rating: 0,
      reviews: [
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 4,
          author: "Amanda Dolington"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 2,
          author: "Cris Dolington"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 5,
          author: "John Doe"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 1,
          author: "Alison"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 3,
          author: "Jess"
        }
      ]
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openAppStore() {
      window.open(
        "https://apps.apple.com/us/app/galaxy-birds-space-shooting/id1414776043",
        "_blank"
      );
    }
  }
};
</script>

<style scoped>
.header {
  background-image: url("../../assets/galaxyBirds/header.png");
  background-size: cover;
  min-height: 850px;
  height: 100vh;
  background-position: bottom 70px right 0px;
}
.header-content {
  height: 100vh;
}
.store_btn {
  cursor: pointer;
  margin-top: 70px;
}
.app-title {
  font-family: "HelveticaNeue";
  font-size: 5vh;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #ffffff;
  margin-top: 50px;
}
.description {
  font-family: "HelveticaNeue";
  font-size: 2vh;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  margin-top: 30px;
}
.player-yellow {
  margin-bottom: 100px;
}
.main-features {
  background-color: #120c31;
  padding-top: 200px;
  margin-top: -100px;
}
.features-title {
  font-family: "HelveticaNeue";
  font-size: 60px;
  font-weight: bold;
  line-height: 1.23;
  text-align: left;
  color: #ffffff;
  margin-bottom: 60px;
  text-align: center;
}
.features-item {
  font-family: "HelveticaNeue";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}
.rating {
  background-color: #120c31;
}
.rating-title {
  font-family: "HelveticaNeue";
  font-size: 60px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.pointer {
  cursor: pointer;
}
.review-author {
  font-family: "HelveticaNeue";
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin-top: 40px;
}
.download-container {
  background-color: #120c31;
  background-image: url("../../assets/galaxyBirds/bg_footer.png");
  background-size: contain;
}
.download-app {
  font-family: "HelveticaNeue";
  font-size: 4vh;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}
.footer {
  background-color: #120c31;
  padding-top: 70px;
}
</style>